export const iconFontAwesomeCampingPersonHiking = (
	<i className="fa-solid fa-person-hiking"></i>
);
